import React from 'react';
import type { EmailMenuState } from '../../../types/table';
import { getAppUrl } from '../../../utils/validation';
import { TABLE_Z_INDEX } from '../../../constants/table';

export interface EmailContextMenuProps {
  menuState: EmailMenuState;
  isPublicView?: boolean;
  onSendEmail: () => void;
}

/**
 * Context menu for email cells with option to send email
 */
export const EmailContextMenu: React.FC<EmailContextMenuProps> = ({
  menuState,
  isPublicView = false,
  onSendEmail,
}) => {
  if (!menuState.show) return null;

  return (
    <div
      className="popup-container fixed bg-white border border-gray-200 rounded shadow-lg p-2"
      style={{
        left: menuState.x,
        top: menuState.y,
        zIndex: TABLE_Z_INDEX.CONTEXT_MENU,
      }}
    >
      {isPublicView ? (
        <div className="p-3 text-center">
          <div className="text-gray-900 text-sm mb-3">Login to send emails</div>
          <button
            id="email-context-login-btn"
            onClick={() => window.open(getAppUrl(), '_blank')}
            className="px-4 py-2 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 transition-colors"
          >
            Login to Skylarq
          </button>
        </div>
      ) : (
        <button
          id="send-email-context-btn"
          onClick={onSendEmail}
          className="flex items-center text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded transition-all duration-200 whitespace-nowrap w-full"
        >
          <svg
            className="w-4 h-4 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
          Send Email
        </button>
      )}
    </div>
  );
};

EmailContextMenu.displayName = 'EmailContextMenu';
